import React from "react";
import { TitleProps } from "@pankod/refine-core";
import routerProvider from "@pankod/refine-react-router-v6";

const { Link } = routerProvider;

export const Title: React.FC<TitleProps> = ({ collapsed }) => (
  <Link to="/">
    {collapsed ? (
      <img
        src={"/pn-logo.png"}
        alt="Patriot News"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "50px",
          // height: "50px",
          // padding: "12px 24px",
        }}
      />
    ) : (
      <img
        src={"/pn-logo.png"}
        alt="Patriot News"
        style={{
          width: "200px",
          padding: "12px 24px",
        }}
      />
    )}
  </Link>
);
